import { Navigate } from "react-router";

import { useAuthenticationContext } from "../auth/use-authentication-context";

export const ProtectedRouteGuard: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { user, isSuperuserActingBehalfOfCompany } = useAuthenticationContext();

  if (isSuperuserActingBehalfOfCompany) return children;

  if (!user?.id) return <Navigate to="/login" />;

  if (!user?.isEmailVerified)
    return <Navigate to="/email-verification-waiting-room" />;

  if (user?.isSuperuser) return <Navigate to="/admin/users" />;

  return children;
};
